export default __webpack_public_path__ + "static/141949564b59fe9dbef38854011ef9dd.png";